import * as types from './types';
import Api from '../../../../../../lib/api';
import { toast } from 'react-toastify';

const Alerts = require ('../../../../../alerts');

export const setFetchingSettings = (condition) => {
  return {
    type: types.SET_FETCHING_HOLDER_SETTINGS,
    payload: condition,
  };
};
export const setSettingsError = (error) => {
  return {
    type: types.SET_HOLDER_SETTINGS_ERROR,
    payload: error
  };
};
export const setSendSettingsError = (error) => {
  return {
    type: types.SET_HOLDER_SEND_SETTINGS_ERROR,
    payload: error
  };
};

export const setFetchingIntegrations = (condition) => {
  return {
    type: types.SET_FETCHING_HOLDER_INTEGRATIONS,
    payload: condition,
  };
};

export const setIntegrationsError = (error) => {
  return {
    type: types.SET_HOLDER_INTEGRATIONS_ERROR,
    payload: error
  };
};
export const fetchSettings = (holderId, callback) => {
  return (dispatch, getState) => {
    const { login: { authToken }, localization } = getState();
    const { errorDefault, errorConnection } = localization.strings.holderSettings.errors;

    dispatch(setFetchingSettings(true));

    return Api.get(`cf/holderSettings?holderId=${holderId}`, authToken)
    .then(response => {
      const { success, data } = response.data;
      if(success) {
        dispatch(setFetchingSettings(false));
        if (callback) callback((data && data.length > 0) ? data[0] : []);
      } else {
        dispatch(setSettingsError(errorDefault));
      }
    })
    .catch(() => {
      dispatch(setSettingsError(errorConnection));
    });
  };
};

export const sendSettings = (settings, callback) => {
  return (dispatch, getState) => {
    const { login: { authToken }, localization } = getState();
    const { errorDefault, errorConnection } = localization.strings.holderSettings.errors;

    dispatch(setFetchingSettings(true));

    return Api.put(`cf/holderSettings`, settings, authToken)
    .then(response => {
      const { success } = response.data;
      if(success) {
        dispatch(setFetchingSettings(false));
        if (callback) callback();
      } else {
        dispatch(setSendSettingsError(errorDefault));
      }
    })
    .catch(() => {
      dispatch(setSendSettingsError(errorConnection));
    });
  };
};

export const fetchIntegrations = (holderId, callback) => {
  return (dispatch, getState) => {
    const { login: { authToken }, localization } = getState();
    const { errorDefault, errorConnection } = localization.strings.holderSettings.errors;

    dispatch(setFetchingIntegrations(true));

    return Api.get(`cf/integrations?holderId=${holderId}`, authToken)
      .then(response => {
        const { success, data } = response.data;
        if (success) {
          dispatch(setFetchingIntegrations(false));
          if (callback) callback(data);
        } else {
          dispatch(setIntegrationsError(errorDefault));
        }
      })
      .catch(() => {
        dispatch(setIntegrationsError(errorConnection));
      });
  };
};

export const createOrUpdateIntegration = (integration, callback) => {
  return (dispatch, getState) => {
    const { login: { authToken }, localization } = getState();
    const { errorDefault, errorConnection } = localization.strings.holderSettings.errors;

    dispatch(setFetchingIntegrations(true));

    return Api.post(`cf/integrations`, integration, authToken)
      .then(response => {
        const { success } = response.data;
        if (success) {
          Alerts.showAlertMessage(
            'success',
            'Integration settings saved successfully and sync process initiated.',
            () => {}
          );
          dispatch(setFetchingIntegrations(false));
          if (callback) callback();
        } else {
          dispatch(setIntegrationsError(errorDefault));
        }
      })
      .catch(() => {
        Alerts.showAlertMessage(
            'error',
            'Error updating integration. Please try again.',
            () => {}
          );
        dispatch(setIntegrationsError(errorConnection));
      });
  };
};

export const updateIntegrationStatus = (integration, callback) => {
  return (dispatch, getState) => {
    const { login: { authToken }, localization } = getState();
    const { errorDefault, errorConnection } = localization.strings.holderSettings.errors;

    dispatch(setFetchingIntegrations(true));

    return Api.put(`cf/integrations`, integration, authToken)
      .then(response => {
        const { success } = response.data;
        if (success) {
          Alerts.showAlertMessage(
            'success',
            `Integration settings ${integration.enabled ? 'enabled' : 'disabled'} successfully`,
            () => {}
          );
          dispatch(setFetchingIntegrations(false));
          if (callback) callback();
        } else {
          dispatch(setIntegrationsError(errorDefault));
        }
      })
      .catch(() => {
        Alerts.showAlertMessage(
            'error',
            'Error on changing integration status. Please try again.',
            () => {}
          );
        dispatch(setIntegrationsError(errorConnection));
      });
  };
};
